<template>
  <div>
    <!-- popup -->
    <v-dialog />
    <!-- end popup -->
    <!-- snackbar  -->
    <v-snackbar
      v-model="snack_bar"
      :color="snack_color"
      :multi-line="true"
      :timeout="-1"
      top
    >
      <v-col>
        <v-row>
          <v-row class="snack_bar_row">
            <p v-html="snack_text" />
            <v-progress-linear
              color="white"
              :class="{hidden: !in_process }"
              indeterminate
            />
          </v-row>
          <v-btn
            text
            :class="{hidden: in_process }"
            @click="snack_bar = false"
          >
            Close
          </v-btn>
        </v-row>
      </v-col>
    </v-snackbar>
    <!-- end snackbar -->
  </div>
</template>
<script>
  import {
    mapState,
  } from 'vuex'
  export default {
    name: 'Alert',
    data () {
      return {
        // rebuild
        snack_bar: false,
      }
    },
    computed: {
      ...mapState(['in_process', 'snack_text', 'snack_color']),
    },
    created () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'Notify') {
          this.ShowSnackBar()
        } else if (mutation.type === 'CloseAlert') {
          this.CloseAlert()
        } else if (mutation.type === 'ShowError') {
          this.ShowError()
        }
      })
    },
    methods: {
      ShowSnackBar () {
        this.snack_bar = true
        if (this.snack_text === '') this.$store.commit('SET_SNACK_TEXT', 'Saving data...')
        this.$store.commit('SET_IN_PROCESS', true)
      },
      CloseAlert () {
        this.$store.commit('SET_IN_PROCESS', false)
        this.snack_bar = false
      },
      ShowError () {
        this.snack_bar = true
        this.$store.commit('SET_SNACK_COLOR', 'error')
        if (this.snack_text === '') this.$store.commit('SET_SNACK_TEXT', 'An error has occurred!')
        this.$store.commit('SET_IN_PROCESS', false)
        setTimeout(() => { this.snack_bar = false }, 2000)
      },
    },
  }
</script>
